<template>
    <div class="collapse-container">
        <div class="collapse-title" @click="handleShow">
            <slot name="title" :isShow="isShow"></slot>
        </div>
        <div class="collapse-content" :class="{'show': isShow}">
            <div>
                <slot name="content" :isShow="isShow"></slot>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import useBasicStore from '~/store/modules/basic'
const basicStore = useBasicStore()
const { isDesktop } = storeToRefs(basicStore)

const isShow = ref(false)
const handleShow = () => {
    isShow.value = !isShow.value
}

</script>

<style lang="scss" scoped>
.collapse-container{
    .collapse-content{
        display: grid;
        grid-template-rows: 0fr;
        transition: .3s;
        overflow: hidden;
        > div {
            min-height: 0;
            overflow: hidden;
        }
        &.show {
            grid-template-rows: 1fr;
        }
    }
}
</style>